export enum DigihavenComponentType {
    RetentionPeriod = 'RetentionPeriod',
    SeriesProcess = 'SeriesProcess',
    SeriesServiceIpdc = 'SeriesServiceIpdc',
    RecordReuse = 'RecordReuse',
    DossierPublicity = 'DossierPublicity',
    DocumentPublicity = 'DocumentPublicity'
}
